var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterTap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 47.06,
    y: 65.92,
    width: 21.6,
    height: 61.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 101.06,
    y: 72.4,
    width: 26.64,
    height: 12.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.5,99.8v33.8H153.62V107h-85V86.08h92.12A13.72,13.72,0,0,1,174.5,99.8Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 114.02,
    y1: 45.76,
    x2: 114.02,
    y2: 72.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 94.58,
    y1: 45.76,
    x2: 134.9,
    y2: 45.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175.49,169.69a10.71,10.71,0,1,1-21.42,0c0-9,10.71-24.57,10.71-24.57S175.49,159,175.49,169.69Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterTap);
export default __webpack_public_path__ + "static/media/WATER_TAP.4c2a65576a6b9256e5d4e934d21d49c0.svg";
export { ForwardRef as ReactComponent };